import { getPermissions } from "@/helper/collection";

export const ACLRoutes = {
    path: "access-control-list",
    name: "Access Control List",
    redirect: "access-control-list/access-control-list-master",
    component: {
        render(c) {
            return c("router-view");
        }
    },
    children: [{
        path: 'access-control-list-master',
        name: 'Access Control List Master',
        component: () => import('@/components/Pages/AccessControlList/accessControlListMaster'),
        meta: {
            permissions: getPermissions(['SuperAdmin', 'CinemaManager', 'HoManager', 'RoleRoleManagement'], true, '', 125, 1)
        }
    },
    {
        path: 'edit-access-control',
        name: 'Edit Access Control',
        component: () => import('@/components/Pages/AccessControlList/editAccessContol.vue'),
        meta: {
            permissions: getPermissions(['SuperAdmin', 'CinemaManager', 'HoManager', 'RoleRoleManagement'], true, '', 125, 2)
        }
    },
    {
        path: 'view-access-control',
        name: 'View Access Control',
        component: () => import('@/components/Pages/AccessControlList/viewAccessControl.vue'),
        meta: {
            permissions: getPermissions(['SuperAdmin', 'CinemaManager', 'HoManager', 'RoleRoleManagement'], true, '', 125, 1)
        }
    },

    ]
}



// WEBPACK FOOTER //
// ./src/router/aclRoutes.js